import React, {Dispatch, FC, SetStateAction} from 'react';
import {CustomButton} from "../../../../../../components/UI/AntCustom/CustomButton";
import {defineMessages, useIntl} from "react-intl";
import {CommonButtonMessages} from "../../../../../../intl/commonMessages/CommonButtonMessages";
import styled from "styled-components";
import CloseIcon from "../../../../../../media/icons/close.svg?react";
import Modal from "antd/es/modal/Modal";

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 15px;
    padding: 0;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    display: none;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #E0E0E0;
`;

const HeaderTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 22px;
  color: #000000;
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  width: 39px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  
  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: #808080;
    }
  }
  
  &:hover {
    opacity: 0.7;
  }
`;

const ModalBody = styled.div`
  padding: 40px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalMessage = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 28.8px;
  color: #000000;
  text-align: center;
  margin-bottom: 24px;
  white-space: pre-wrap;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const SecondaryButton = styled(CustomButton)`
  border: 1px solid #1890FF !important;
  background: #FFFFFF !important;
  color: #1890FF !important;
  
  &:hover {
    background: #F0F0F0 !important;
    border-color: #40A9FF !important;
    color: #40A9FF !important;
  }
`;

const FlyHourPriceCalculatorExitModalMessages = defineMessages({
  headerTitle: {
    id: "flyHourPriceCalculatorExitModal.headerTitle",
    defaultMessage: "Are you sure you want to exit?",
  },
  message: {
    id: "flyHourPriceCalculatorExitModal.message",
    defaultMessage: "Are you sure you want to exit without completing the calculator? Changes will not be applied.",
  },
  exit: {
    id: "flyHourPriceCalculatorExitModal.exit",
    defaultMessage: "Exit",
  },
});

interface IFlyHourPriceCalculatorExitModal {
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
  onExit: () => void;
}

export const FlyHourPriceCalculatorExitModal: FC<IFlyHourPriceCalculatorExitModal> = ({
  isModalVisible,
  setIsModalVisible,
  onExit,
}) => {
  const intl = useIntl();

  const handleExit = () => {
    onExit();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <StyledModal
      title={null}
      open={isModalVisible}
      onCancel={handleCancel}
      centered
      footer={null}
      width={545}
      closable={false}
      maskClosable={false}
    >
      <ModalHeader>
        <HeaderTitle>
          {intl.formatMessage(FlyHourPriceCalculatorExitModalMessages.headerTitle)}
        </HeaderTitle>
        <CloseButton onClick={handleCancel}>
          <CloseIcon />
        </CloseButton>
      </ModalHeader>

      <ModalBody>
        <ModalMessage>
          {intl.formatMessage(FlyHourPriceCalculatorExitModalMessages.message)}
        </ModalMessage>

        <ButtonsContainer>
          <CustomButton
            block
            type="primary"
            onClick={handleExit}
          >
            {intl.formatMessage(FlyHourPriceCalculatorExitModalMessages.exit)}
          </CustomButton>
          <SecondaryButton
            block
            onClick={handleCancel}
          >
            {intl.formatMessage(CommonButtonMessages.cancel)}
          </SecondaryButton>
        </ButtonsContainer>
      </ModalBody>
    </StyledModal>
  );
};

